import { NavLink, useLocation } from 'react-router-dom';
import Icon from '../common/Icon';
import './Sidebar.css';

const navItems = [
  { section: 'Overview', items: [
    { path: '/', icon: 'dashboard', label: 'Dashboard' },
    { path: '/tenants', icon: 'building', label: 'Tenants' },
    { path: '/users', icon: 'users', label: 'Users' },
  ]},
  { section: 'Security', items: [
    { path: '/fraud', icon: 'shield', label: 'Fraud Dashboard' },
    { path: '/activity', icon: 'activity', label: 'Activity Log' },
  ]},
  { section: 'Billing', items: [
    { path: '/revenue', icon: 'dollar-sign', label: 'Revenue' },
    { path: '/plans', icon: 'clipboard', label: 'Plans & Pricing' },
  ]},
  { section: 'Configuration', items: [
    { path: '/developers', icon: 'key', label: 'Developers' },
    { path: '/whitelabel', icon: 'sparkles', label: 'Whitelabel Wizard' },
    { path: '/fraud-config', icon: 'settings', label: 'Fraud Config' },
    { path: '/settings', icon: 'settings', label: 'Global Settings' },
    { path: '/ai-loadbalancer', icon: 'brain', label: 'AI Load Balancer' },
  ]},
  { section: 'Lazy Marketing', items: [
    { path: '/marketing', icon: 'rocket', label: 'CEO Dashboard' },
    { path: '/marketing/overview', icon: 'bar-chart', label: 'Overview' },
    { path: '/marketing/content', icon: 'edit', label: 'Content' },
    { path: '/marketing/agents', icon: 'robot', label: 'AI Agents' },
    { path: '/marketing/campaigns', icon: 'target', label: 'Campaigns' },
    { path: '/marketing/leads', icon: 'users', label: 'Leads' },
    { path: '/marketing/video', icon: 'video', label: 'Video & Avatar' },
    { path: '/marketing/email', icon: 'mail', label: 'Email' },
    { path: '/marketing/ads', icon: 'megaphone', label: 'Ads' },
    { path: '/marketing/sms', icon: 'phone', label: 'SMS' },
    { path: '/marketing/social', icon: 'globe', label: 'Social' },
    { path: '/marketing/analytics', icon: 'trending-up', label: 'Analytics' },
  ]},
];

const Sidebar = () => {
  const location = useLocation();

  return (
    <aside className="sidebar">
      {navItems.map((section) => (
        <nav key={section.section} className="nav-section">
          <div className="nav-label">{section.section}</div>
          {section.items.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `nav-item ${isActive ? 'active' : ''}`
              }
              end={item.path === '/'}
            >
              <span className="nav-icon">
                <Icon name={item.icon} size="sm" />
              </span>
              {item.label}
            </NavLink>
          ))}
        </nav>
      ))}
    </aside>
  );
};

export default Sidebar;
